import type { AxiosError } from 'axios';

interface ApiErrorResponse {
  status?: string;
  message?: string;
  code?: string;
  details?: unknown;
}

export const resolveApiErrorMessage = (error: unknown, fallback: string) => {
  const isAxios = (value: unknown): value is AxiosError<ApiErrorResponse> =>
    typeof value === 'object' &&
    value !== null &&
    'isAxiosError' in value &&
    Boolean((value as { isAxiosError?: boolean }).isAxiosError);

  if (isAxios(error)) {
    return error.response?.data?.message ?? fallback;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};
